import { useState, useEffect } from 'react';

const CMS_BASE = process.env.REACT_APP_CMS_BASE_URL
  || process.env.REACT_APP_API_BASE
  || '';

export function useCmsPage(site, slug) {
  const [pageData, setPageData] = useState(null);
  useEffect(() => {
    if (!CMS_BASE) return;
    let cancelled = false;
    fetch(`${CMS_BASE}/api/websites/pages/${site}/${slug}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (!cancelled) setPageData(data?.sections ? data : null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [site, slug]);
  return pageData;
}

// Reads a field from CMS published page data. Returns fallback if absent.
// sectionKey: matches section.key in the published.sections array
// field: dot-separated path within section.content (e.g. 'items', 'headline')
export function c(pageData, sectionKey, field, fallback) {
  const section = (pageData?.sections || []).find(s => s.key === sectionKey);
  if (!section?.content) return fallback;
  if (!field) return section.content;
  const keys = field.split('.');
  let val = section.content;
  for (const k of keys) {
    if (val == null) return fallback;
    val = val[k];
  }
  return (val !== undefined && val !== null && val !== '') ? val : fallback;
}
